import React, { useMemo, useState } from 'react';
import Form from 'react-bootstrap/esm/Form';
import { useDispatch, useSelector } from 'react-redux';
import { IReducer } from '../../../../../../../../redux/configureStore';
import { getAllPartnersList } from '../../../../../../../../redux/fetchActions/legadoPage/clientsApp';
import Wrapper from '../../../../../../../../shared/components/Wrapper';
import GetPartners from './function';
import { ISetPartner } from './function/interfaces';

function SetPartnerSelect(props: ISetPartner) {
  const { set, info, orientation } = props;
  const dispatch = useDispatch();
  const [isActive, setIsActive] = useState(true);

  const profileUserState = useSelector(
    (reducer: IReducer) => reducer.userProfile
  );
  const profilePartnerState = useSelector(
    (reducer: IReducer) => reducer.partnerProfile
  );
  const filterState = useSelector(
    (reducer: IReducer) => reducer.clientsApp.partnersList
  );

  function setAccount(event: React.FormEvent<any>) {
    const { value } = event.currentTarget;
    set(value);
  }

  const [partnerFilter, setPartnerFilter] = useState(filterState);

  useMemo(() => {
    if (profileUserState.partnerId === 1) {
      dispatch(getAllPartnersList());
      setIsActive(true);
    } else {
      set(profilePartnerState.idLegado.toString());
      setIsActive(false);
    }
  }, [profileUserState.nivel]);

  useMemo(() => {
    setPartnerFilter(filterState);
  }, [filterState]);

  return (
    <Wrapper.Default isActive={isActive} flexDirection={orientation || 'row'}>
      <Wrapper.Label>Parceiro:</Wrapper.Label>
      <Form.Control
        as="select"
        style={{ width: '11rem', margin: '0 1rem 0 0.25rem' }}
        value={info}
        onChange={(event) => setAccount(event)}>
        <GetPartners partnerFilter={partnerFilter} />
      </Form.Control>
    </Wrapper.Default>
  );
}

export default SetPartnerSelect;
